import React, { useEffect, useState } from 'react';
import DTOPopupModal from './DTOPopupModal';
import PopupModalPresenter from './PopupModalPresenter';
import { personalInfoType } from '../../../interfaces/myProfile/personalDetails/personalInfo';
import { updatePersonalDetailsService } from '../../../../api/services/updatePersonalDetailsService';
import { useAppDispatch, useAppSelector } from '../../../../infra/hooks';
import { updatePersonalInfo } from '../../../../infra/aggregates/myProfile/personalInfoSlice';
import moment from 'moment';
import toast from 'react-hot-toast';
import { commonServices } from '../../../../api/services/commonServices';

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  trans?: any;
}

const PopupModalController = ({
  isModalOpen,
  closeModal,
  trans,
}: ModalInterface) => {
  const selector = useAppSelector((state) => state.personalInfoSlice);
  const empId = useAppSelector((state) => state?.authSlice?.emp_id);
  const dispatch = useAppDispatch();
  const [countries, setCountries] = useState<[]>([]);
  const [allGenders, setAllGenders] = useState<[]>([]);
  const [maritalStatus, setMaritalStatus] = useState<[]>([]);
  const [allStates, setAllStates] = useState<[]>([]);

  const getData = (personalInfoData: personalInfoType) => {
    updatePersonalInfoFunc(personalInfoData);
  };

  async function callBack(data: []) {
    setCountries(data);
  }

  async function callBackGetAllGenders(data: []) {
    setAllGenders(data);
  }

  async function callBackGetMaritalStatus(data: []) {
    setMaritalStatus(data);
  }
  async function updatePersonalInfoFunc(data: personalInfoType) {
    if (empId) {
      const payload = {
        first_name: data.firstName,
        last_name: data.lastName,
        dob: moment(data.DOB).format('YYYY-MM-DD'),
        gender: data.gender,
        marital_status: data.martialStatus,
        country_id: data.country,
        email: data.email,
        phone: data.phone,
        state_id: data.stateId,
        education: data.education,
        religious: data.religious,
        nationalityId: data.nationalityId,
      };

      await updatePersonalDetailsService
        .updatePersonalInfo(empId, payload)
        .then((response: any) => {
          if (response.status == 'success') {
            const personalInfoData: personalInfoType = {
              firstName: response?.data.first_name,
              lastName: response?.data.last_name,
              DOB: response?.data.dob,
              gender: response?.data?.gender_name?.name,
              martialStatus: response?.data?.marital_status?.name,
              country: response?.data?.country?.name,
              state: response?.data?.state?.name,
              stateId: response?.data?.state?.id,
              email: response?.data?.email,
              phone: response?.data?.phone,
              countryId: response?.data?.country.id,
              genderId: response?.data?.gender_name?.id,
              maritalStatusId: response?.data?.marital_status?.id,
              education: response?.data?.education,
              religious: response?.data?.religious,
              nationalityId: response?.data?.country_of_birth.id,
              nationalityName: response?.data?.country_of_birth.name,
            };
            dispatch(updatePersonalInfo(personalInfoData));
            toast.success(trans('Updated Successfully'));
            closeModal();
          }
        })
        .catch((err) => {
          const _errors = Object.keys(err?.response?.data?.errors);
          toast.error(`${_errors.toString().toUpperCase()} Required!`);
        });
    } else {
      toast.error(trans('Invalid data'));
    }
  }

  async function getCountryStates(id: number) {
    await commonServices
      .getStates(id)
      .then((response: any) => {
        setAllStates(response?.data);
      })
      .catch((err) => console.log(err));
  }
  return (
    <div>
      <DTOPopupModal
        setAllCountries={callBack}
        setAllGenders={callBackGetAllGenders}
        setAllMaritalStatus={callBackGetMaritalStatus}
      />
      <PopupModalPresenter
        callBackHandleClockIn={getData}
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        allCountires={countries}
        allStates={allStates}
        allGenders={allGenders}
        allMaritalStatus={maritalStatus}
        selectedEmployeeDetail={selector}
        selectedCountryId={getCountryStates}
        trans={trans}
      />
    </div>
  );
};

export default PopupModalController;
